var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.experts)?_c('div',{staticClass:"container my-20 grid grid-cols-1 md:grid-cols-2 gap-10"},_vm._l((_vm.experts),function(expert,index){return _c('ExpertPreview',{key:index,staticClass:"col-span-1",attrs:{"expert":expert}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }